"use client";

import { useSearchParams } from "next/navigation";
import { useCallback, useMemo } from "react";

import { AlertsButton } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/alerts/alerts-button.container";
import { ALERTS_BUTTON_VARIANTS } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/alerts/alerts-trigger-button.view";
import {
  VIEW_MODES,
  type ViewMode,
} from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/constants";
import { MobileActionBarView } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/mobile-action-bar";
import { mobileActionBarTestIds } from "@/lib/data-test-ids/jobs.data-test-ids";

export default function MobileActionBarContainer() {
  const searchParams = useSearchParams();

  const viewMode = useMemo(
    () => (searchParams.get("viewMode") || VIEW_MODES.list) as ViewMode,
    [searchParams],
  );

  const getModeUrl = useCallback(
    (mode: ViewMode) => {
      const newParams = new URLSearchParams(searchParams.toString());
      newParams.set("viewMode", mode);
      return `?${newParams.toString()}`;
    },
    [searchParams],
  );

  return (
    <MobileActionBarView
      viewMode={viewMode}
      getModeUrl={getModeUrl}
      alertsSlot={
        <AlertsButton
          variant={ALERTS_BUTTON_VARIANTS.compact}
          testId={mobileActionBarTestIds.ALERTS_BUTTON}
        />
      }
    />
  );
}
